import React from 'react'
import Educator from './educator/Educator';
import Logo from '../../img/logo2.svg'
import classes from './Header.module.css';
import { Link } from 'react-router-dom';

const Header = (props) => {

    const onLanguageClick = (event) => {
        props.languageHandler(event.target.value);
    }

    return (
    <header className={classes.header}>
        <div className={classes.logo}>
            <Link to="/"  title="Link do strony głównej" className={classes.logo__link}>
              <img src={Logo} alt="Indigo Nails" title="Logo Indigo Nails" className={classes.header__logo}/>
            </Link>
            <div className={classes.header__language}>
                <Link to="/de">
                    <button className={classes.header__languageButton} value="de" onClick={onLanguageClick}>        
                        Deutsch
                    </button>
                </Link>
                <p className={classes.header__slash}>/</p>
                <Link to="/en">
                    <button className={classes.header__languageButton} value="en" onClick={onLanguageClick}>
                        English
                    </button>
                </Link>
            </div>
        </div>
        <Educator  
            onTranslate={props.onTranslate}
        />
    </header>
  )
}

export default Header;